import React, { useState } from "react";
import { Row, Col, Button, Card, Form, Modal } from "react-bootstrap";
import ApiOrderService from "../../../../../core/api/api.ordersService";
import { isMobile } from "react-device-detect";
import Swal from "sweetalert2";
import ApiBasketTemp from "../../../../../core/api/api.basketTemp";
import ModalManager from "../ModalManager";
import _ from "lodash";
import SwalMessage from "../../../_Components/SwalMessage";

function NewBasketItemsIndex(props) {
  //PART 1 --------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  const [checkBoxList, setCheckBoxList] = useState([]); //-----------------------لیستی از افرادی که برای انجام عملیات انتخاب میشوند
  const [desValue, setDesValue] = useState(""); //-----------------------------------توضیحاتی که در اجرای عملیات برای شخص ثبت میشود در این استیت یا متغیر  ذخیره میشود
  // const [showModalChangePerson, setShowModalChangePerson] = useState(false);
  const [personsForEdit, setPersonsForEdit] = useState({});
  const [basketItemId, setBasketItemId] = useState(0);
  const [show2, setShow2] = useState(false);
  const [namedesc, setnamedesc] = useState();
  const [current, setCurrent] = useState();
  const [serviceNameSelected, setserviceNameSelected] = useState();
  const [showModalAddPersonToItem, setShowModalAddPersonToItem] = useState(false);
  // const [selectedItemForEdit, setSelectedItemForEdit] = useState([]);
  const [showModalUpdatePersonInItem, setShowModalUpdatePersonInItem] = useState(false);
  const [operatorCanceledMdal, setoperatorCanceledMdal] = useState(false);

  // const showDetails = "";
  // const pageHeight = window.innerHeight;
  //PART 3 --------------------------------------------------------------------------------------------------------------------------------------------------
  // const [Modali, setItem] = ModalManager();
  // const handleShow =
  //   ({ nameModal, size, data }) =>
  //     (event) => {
  //       setItem({
  //         show: true,
  //         size: size,
  //         nameModal: nameModal,
  //         data: data,
  //       });
  //     };

  // PART 4 ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

  const handleClose = () => setShow2(false);
  // update person in basket
  const handleUpdate = (current) => {
    if (current == 0) {
      !_.isEmpty(checkBoxList)
        ? setoperatorCanceledMdal(!operatorCanceledMdal)
        : SwalMessage({
          title: "جهت ثبت کنسلی ابتدا آیتم های مدنظر را انتخاب نمایید.",
          iSsuccess: false,
          timer: 4000,
        });
    } else {
      (async () => {
        const listId = checkBoxList.map((item) => item.id);
        // const listCurrent = checkBoxList.map((item) => item.current);
        const data = {
          basketId: parseInt(props.basketId),
          listId: listId,
          currentStatus: current,
          description: desValue,
        };

        const response = await ApiOrderService.update(data);
        setShow2(false);
        setCheckBoxList([]);
        props.callBack();
        SwalMessage({ title: response.message, iSsuccess: response.succeeded });
      })();
    }
  };

  // PART 5------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

  // handleSelect add or remove item id from checkBox list
  const handleSelect = (id, current, basketItemId) => {
    const data = { id: id, current: current, basketItemId: basketItemId };
    checkBoxList.some((item) => data.id === item.id)
      ? setCheckBoxList((checkBoxList) => checkBoxList.filter((item) => item.id != data.id))
      : setCheckBoxList((checkBoxList) => [...checkBoxList, data]);
  };

  // select all button
  const handleAllSelect = (list, boolian) => {
    if (!boolian) {
      const listFalseItem = list.filter((item) => !checkBoxList.some((data) => item.id === data.id));

      listFalseItem.map((item) => handleSelect(item.id, item.currentStatus, item.basketItemId));
    } else if (boolian) {
      const listTrueItem = list.filter((item) => checkBoxList.some((data) => item.id === data.id));

      listTrueItem.map((item) => handleSelect(item.id, item.currentStatus, listTrueItem.basketItemId));
    }
  };

  // PART 6--------------------------------------------------------------------------------------------------------------------------------------------------------------------------

  // SHHOW MODAL FOR GET DESCRIBTION
  // const handlemodaldescrib = (namedescs, currents) => {
  //   setShow2(true);
  //   setnamedesc(namedescs);
  //   setCurrent(currents);
  // };

  const handleDescrib = (current) => {
    // const listId = checkBoxList.map(item => item.id);
    // const listCurrent = checkBoxList.map(item => item.current);

    // if (listCurrent.some(item =>
    //   (item === 4 || item === 3) ||
    //   (item === 0 && current != 1) ||
    //   (listId.length === 0) ||
    //   (item === 2 && current != 1))) { handleUpdate(current); setShow2(false) } else {
    //   checkBoxList.map(item => {
    //     (async () => {
    //       const data = {
    //         "logType": 1,
    //         "value": desValue,
    //         "description": desValue,
    //         "basketId": props.basketId,
    //         "basketItemId": null,
    //         "basketPersonId": item.id,
    //         "transactionId": null
    //       }
    handleUpdate(current);

    // const response = await ApiBasketLog.postDescrib(data)
    //  props.callBack()
    // setShow2(false)

    // })();
    //   }
    //   )
    // }
  };

  const getInputValueDescription = (event) => {
    const desValue = event.target.value;
    setDesValue(desValue);
  };

  // ===========================================================================]
  const handleModalChangePerson = (personForEdit, basketId, amusementServiceName) => {
    setShowModalUpdatePersonInItem(!showModalUpdatePersonInItem);
    setPersonsForEdit(personForEdit);
    setBasketItemId(basketId);
    setserviceNameSelected(amusementServiceName);
  };
  // const RemoveItemPerson = (personForEdit, basketId, amusementServiceName) => {
  //   setShowModalUpdatePersonInItem(!showModalUpdatePersonInItem);
  //   setPersonsForEdit(personForEdit);
  //   setBasketItemId(basketId);
  //   setserviceNameSelected(amusementServiceName);
  // };
  const handleRemoveItem = (item) => {
    setPersonsForEdit(item);
    setShowModalUpdatePersonInItem(!showModalUpdatePersonInItem);
  };
  const callBackUpdatePerson = () => {
    setShowModalUpdatePersonInItem(!showModalUpdatePersonInItem);
    props.callBack();
  };
  const callBackUpdatePerson2 = () => {
    setShowModalUpdatePersonInItem(!showModalUpdatePersonInItem);
    props.callBack();
  };

  // ----------------------------------------------------------------------------
  // const handleModalSegane = (basketId, item) => {
  //   setBasketItemId(basketId);
  //   setShowModalAddPersonToItem(!showModalAddPersonToItem);
  //   setSelectedItemForEdit(item);
  // };
  const callBackAddPerson = () => {
    setShowModalAddPersonToItem(!showModalAddPersonToItem);
    props.callBack();
  };

  const callBackAddperson2 = () => {
    setShowModalAddPersonToItem(!showModalAddPersonToItem);
  };

  // =--------------------------------------------------------------------------------

  function showDetail(prp) {
    let resDetails = "";
    let jsonparser = JSON?.parse(prp);
    !_.isEmpty(jsonparser) &&
      jsonparser.map((item, index) => {
        if (_.isEmpty(resDetails)) resDetails += item.text;
        else resDetails += " , " + item.text;
      });
    return resDetails != "" ? resDetails : "ندارد";
  }

  let showPrice = Intl.NumberFormat("en-US");

  function ModalConfirmDeleted(item) {
    let type = !_.isEmpty(item?.basketItemPersonTemps) ? 1 : 0;
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md mr-2 p-1 px-5 ",
        cancelButton: "btn btn-secondary  btn-md ml-2 p-1 px-5 ",
      },
      buttonsStyling: false,
    });
    let htmlarray = {
      0:
        " آیا " +
        item.personFullName +
        " با شماره بلیط #" +
        item.id +
        " از آیتم  " +
        serviceNameSelected +
        " حذف شود ؟ ",
      1: " آیا آیتم " + item.amusementServiceName + " از سبد فعلی حذف شود ؟",
    };
    swalWithBootstrapButtons
      .fire({
        html: htmlarray[type],
        title: "عملیات حذف",
        icon: "question",
        showConfirmButton: true,
        confirmButtonText: "  <small class='m-0'> بله  </small>",

        showCancelButton: true,
        cancelButtonText: "  <small class='m-0'> بستن </small>",
      })
      .then((result) => {
        if (result.value) {
          var objData = {
            basketId: props.basketId,
            basketItemId: type == 0 ? basketItemId : item.id,
            basketItemPersonId: type == 0 ? item.id : 0,
          };
          var rest = ApiBasketTemp.deleteBasketItemPersonTemp(objData).then((result) => {
            SwalMessage({ title: result.message, iSsuccess: result.data });
            callBackUpdatePerson2();
            callBackUpdatePerson();
          });
        }
      });
  }

  const disableOnTrue = (flag, itemm) => {
    if (!_.isUndefined(itemm)) {
      return {
        pointerEvents: flag ? "none" : "initial",
        opacity: flag ? 0.4 : 1,
        paddingBottom: flag ? 7 : "",
      };
    } else
      return {
        pointerEvents: flag ? "none" : "initial",
      };
  };
  return (
    <>
      {/* <Modali /> */}
      {/* --------------------مودال های استفاده شده در این کامپوننت  */}
      {/*   {showModalAddPersonToItem && (
        <ModalAddPersonToItem
          bascketPersons={props.bascketPersons}
          callBack={callBackAddPerson}
          callBack2={callBackAddperson2}
          basketId={props.basketId}
          basketItemId={basketItemId}
        />
      )} */}
      {/* {showModalAddPersonToItem && (
        <AddServiceItems
          callBack={callBackAddPerson}
          callBack2={callBackAddperson2}
          basketId={props.basketId}
          basketItemPerson={props.bascketPersons}
          basketItem={selectedItemForEdit}
        />
      )} */}

      {showModalUpdatePersonInItem && ModalConfirmDeleted(personsForEdit)}
      {/*       (
        <ModalUpdatePersonInItems
          bascketPersons={props.bascketPersons}
          callBack={callBackUpdatePerson}
          callBack2={callBackUpdatePerson2}
          basketId={props.basketId}
          personsForEdit={personsForEdit}
        />
)} */}
      <Modal centered size="md" show={show2} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>{namedesc}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={() => handleDescrib(current)}>
            <Form.Group>
              <Form.Label>توضیحات</Form.Label>
              <Form.Control as="textarea" onChange={getInputValueDescription} />
            </Form.Group>
            <Row>
              <Col xs="12">
                <Button variant="success" type="submit">
                  ثبت
                </Button>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            بستن
          </Button>
        </Modal.Footer>
      </Modal>

      {/* -------------دراپ دون -------------------------------------------------------------------------------------------- */}
      {/* <Dropdown className=" sticky-top " style={{ position: "fixed", top: pageHeight / 2, left: "-16px" }}>
        <Dropdown.Toggle size="sm" drop="up" variant="primary" className=" position-absolute right-0 fa-rotate-270">
          عملیات{" "}
        </Dropdown.Toggle>
        <Dropdown.Menu className="">
          <Dropdown.Item className="m-0 p-0 ">
            <div className="btn-group ml-auto my-0 py-0 col-12 " role="group">
              <button
                className="btn btn-outline-primary btn-sm col-7"
                onClick={() => handleUpdate(1)}
              >
                درحال پیگیری
              </button>
              <button
                className="btn btn-outline-primary btn-sm col-5"
                onClick={() => handlemodaldescrib("درحال پیگیری", 1)}
              >
                توضیحات
              </button>
            </div>
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown> */}

      {/* ========================================================================================================================== */}
      {/* -------------------------ایتم ها ی سبد خرید ------------------------------------------------------------------------------- */}
      <div className="mt-5">
        {props?.basketItems?.map((item, index) => (
          <Card
            key={index}
            className={" rounded-xl mb-1 p-3 bg-white   border border-secondary"}
            style={item?.isDeleted ? disableOnTrue(true, item.id) : disableOnTrue(false, item.id)}
          >
            <Row className="border-bottom align-items-center">
              <Col xs="8">
                <h1 className="fs-large pl-2">{item.amusementServiceName} </h1>
              </Col>
              <Col xs="4">
                <div className="btn-group-sm d-flex justify-content-end mb-3 ">
                  {/* <button
                      type="button"
                      className="btn btn-light-secondary mx-1"
                      onClick={handleShow({
                        nameModal: "historyItem",
                        size: "lg",
                        data: {
                          BasketId: props.basketId,
                          BasketItemId: item.id,
                        },
                      })}
                    >
                      <p className="fas fa-history text-dark fa-sm my-0"></p>
                    </button> */}
                  <button
                    type="button"
                    className="btn btn-light-danger"
                    onClick={() => {
                      handleRemoveItem(item);
                    }}
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    data-bs-custom-class="tooltip-dark"
                    title={" حذف آیتم " + item.amusementServiceName}
                    data-bs-delay-hide="1000"
                  >
                    <p className="far fa-trash-alt  fa-sm   text-start my-0 "></p>
                  </button>
                </div>
              </Col>
            </Row>

            {/*------------------------------------------------------- مشخصات سفارش ------------------------------------------*/}
            <div className="pt-5">
              <Row className="my-0 d-flex justify-content-between">
                <Col xs="12" md="6" className="">
                  <p className="pl-2  text-muted">جزییات سفارش : {showDetail(item.details)}</p>
                </Col>
                <Col xs="6" sm="4" md="2">
                  <p className="text-md-center ">
                    <span className="fas fa-user-tie text-primary mr-2"></span>
                    {item.totalCount} نفر{" "}
                  </p>
                </Col>

                <Col xs="6" sm="4" md="2">
                  <p className="text-md-center ">
                    <span className="far fa-calendar-check text-info mr-2"></span>
                    {item.checkInDate}{" "}
                  </p>
                </Col>

                <Col xs="6" sm="4" md="2" className="">
                  <p className="text-md-center ">
                    <span className="far fa-money-bill-alt text-success mr-2"></span>
                    {showPrice.format(item.sumPrice)}{" "}
                    <span>
                      <small> تومان </small>
                    </span>
                  </p>
                </Col>
              </Row>

              {/* <Row>
                <Col xs="3" sm="5">
                  <hr />
                </Col>
                <Col xs="6" sm="2">
                  <h5 className="text-center mx-0 px-0">لیست افراد</h5>
                </Col>
                <Col xs="3" sm="5">
                  <hr />
                </Col>
              </Row> */}
            </div>

            {/* ------------------------------------------------لیست افراد حاضر در ایتم------------------------------------------------------------ */}
            <div className="mt-1 bg-light rounded-4" style={{ overflowX: isMobile ? "scroll" : "hidden" }}>
              <div className=" d-md-block ">
                <div className="d-flex bg-secondary align-items-center py-2">
                  <Col xs="1" sm="1" md="1" className=" pl-6 ">
                    {" "}
                    <input
                      type="checkbox"
                      onChange={() =>
                        handleAllSelect(
                          item.basketItemPersonTemps,
                          item?.basketItemPersonTemps.filter((item) =>
                            checkBoxList.some((data) => item.id === data.id),
                          ).length === item?.basketItemPersonTemps.length,
                        )
                      }
                      checked={
                        item?.basketItemPersonTemps.filter((item) => checkBoxList.some((data) => item.id === data.id))
                          .length === item?.basketItemPersonTemps.length && item?.basketItemPersonTemps.length > 0
                      }
                      className="ml-6 pl-6 my-1 "
                    />{" "}
                  </Col>

                  <Col xs="1" sm="1" md="1" className="text-hover-primary d-sm-none d-md-none">
                    {" "}
                  </Col>

                  <Col xs="4" sm="2" md="1">
                    <p className="text-center my-1 ml-6 ml-md-0 text-muted"> شماره بلیط</p>
                  </Col>

                  <Col xs="6" sm="3" md="2" className="">
                    <p className="text-center my-1 ml-6 ml-md-0 text-muted"> نام و نام خانوادگی </p>
                  </Col>
                  {item.hallEventId && <Col xs="6" sm="3" md="2" className="">
                    <p className="text-center my-1 ml-6 ml-md-0 text-muted">صندلی</p>
                  </Col>}

                  {/* <Col xs='5' sm='4' md='1'><p className="text-md-center ml-6 ml-md-0 my-1 text-muted"> جنسیت  </p></Col> */}

                  <Col xs="5" sm="3" md="2">
                    <p className="text-center ml-6 ml-md-0 my-1 text-muted"> قیمت </p>
                  </Col>
                  <Col xs="4" sm="2" md="1">
                    <p className="text-center ml-6 ml-md-0 my-1 text-muted"> تخفیف کد </p>
                  </Col>
                  <Col xs="5" sm="3" md="2">
                    <p className="text-center ml-6 ml-md-0 text-muted my-1"> قیمت پرداختی </p>
                  </Col>
                  {/* <Col xs="5" sm="4" md="2">
                    <p
                      className={"text-md-center ml-6 ml-md-0 my-1 text-muted"}
                    >
                      {" "}
                      وضعیت{" "}
                    </p>
                  </Col> */}
                  <Col xs="5" sm="3" md={item.hallEventId ? "1" : "2"} >
                    <p className="text-center ml-6 ml-md-0 my-1 text-muted"> وضعیت کنسلی </p>
                  </Col>

                  <Col xs="4" sm="2" md="1" className="text-center">
                    {/* <button
                        type="button"
                        className="btn btn-outline-primary btn-sm"
                        onClick={() => {
                          handleModalSegane(item.id, item);
                        }}
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        data-bs-custom-class="tooltip-dark"
                        title="اضافه کردن افراد جدید به سبد"
                        data-bs-delay-hide="1000"
                      >
                        <i className="fa fa-plus text-small p-0"></i>
                      </button> */}
                  </Col>
                </div>
              </div>
              {item.basketItemPersonTemps.length !== 0 ? (
                item.basketItemPersonTemps.map((item1, index1) => (
                  <div
                    key={index1}
                    style={item1?.isDeleted || item?.isDeleted ? disableOnTrue(true, item.id) : disableOnTrue(false)}
                    className={item1?.isDeleted ? "text-danger" : ""}
                  >
                    <div
                      className={
                        !isMobile
                          ? "bg-hover-light-primary d-flex  align-items-center"
                          : " d-flex  align-items-center"
                      }
                    >
                      <Col
                        xs="1"
                        sm="1"
                        md="1"
                        className=" pl-6 "
                        onClick={() => handleSelect(item1.id, item1.currentStatus, item1.basketItemId)}
                      >
                        {!item1?.isDeleted && (
                          <input
                            type="checkbox"
                            checked={checkBoxList.some((item) => item1.id === item.id)}
                            className="ml-6 pl-6 my-1"
                            onChange={() => handleSelect(item1.id, item1.currentStatus, item1.basketItemId)}
                          />
                        )}
                      </Col>
                      <Col xs="3" sm="2" md="1" className="text-hover-primary d-none ">
                        <div className="btn-group-sm d-flex justify-content-end mt-3  mx-5">
                          {!item1?.isDeleted && (
                            <button
                              type="button"
                              className="btn text-hover-primary"
                              onClick={() => {
                                // handleModalChangePerson(item1, item.id , item.amusementServiceName);
                              }}
                            >
                              <p className="far fa-trash-alt  fa-sm text-hover-primary text-muted  text-start  "></p>
                            </button>
                          )}
                          {/* {!item1?.isDeleted &&
                            <button
                              type="button"
                              className="btn  text-hover-primary  "
                              onClick={handleShow({
                                nameModal: "historyItem",
                                size: "lg",
                                data: {
                                  BasketId: props.basketId,
                                  BasketItemId: item.id,
                                  BasketItemPersonId: item1.id,
                                },
                              })}
                            >
                              <p className="fas fa-history fa-sm text-hover-primary text-muted"></p>
                            </button>
                          } */}
                        </div>
                      </Col>
                      <Col xs="1" sm="6" md="1" className="d-md-none d-sm-none">
                        {" "}
                      </Col>
                      <Col xs="4" sm="2" md="1" onClick={() => handleSelect(item1.id, item1.currentStatus)}>
                        <p className="text-center my-1 ml-6 ml-md-0 text-hover-primary">{item1.id}</p>
                      </Col>
                      <Col
                        xs="6"
                        sm="3"
                        md="2"
                        className=""
                        onClick={() => handleSelect(item1.id, item1.currentStatus)}
                      >
                        <p className="text-center my-1 ml-6 ml-md-0 text-hover-primary">{item1.personFullName} </p>
                      </Col>

                      {item.hallEventId && <Col
                        xs="6"
                        sm="3"
                        md="2"
                        className=""
                        onClick={() => handleSelect(item1.id, item1.currentStatus)}
                      >
                        <p className="text-center my-1 ml-6 ml-md-0 text-hover-primary">
                          جایگاه: {item1.hallBlockName}
                          <br />
                          ردیف: {item1.hallRowName}
                          <br />
                          صندلی: {item1.hallSeatName}
                        </p>
                      </Col>}

                      {/* <Col xs='5' sm='4' md='1' onClick={() => handleSelect(item1.id, item1.currentStatus)}><p className="text-md-center ml-6 ml-md-0 my-1 text-hover-primary"> {item1.basketPersonGenderS}  </p></Col> */}

                      <Col xs="5" sm="3" md="2" onClick={() => handleSelect(item1.id, item1.currentStatus)}>
                        <p className="text-center ml-6 ml-md-0 my-1 text-hover-primary">
                          {showPrice.format(item1.originalPrice)}{" "}
                          <span>
                            <small> تومان </small>
                          </span>
                        </p>
                      </Col>
                      <Col xs="4" sm="2" md="1" onClick={() => handleSelect(item1.id, item1.currentStatus)}>
                        <p className="text-center ml-6 ml-md-0 my-1 text-hover-primary">
                          {item1.promoCodeDiscountPrice}
                        </p>
                      </Col>
                      <Col xs="5" sm="3" md="2">
                        <p
                          className="text-center ml-6 ml-md-0 text-hover-primary my-1"
                          onClick={() => handleSelect(item1.id, item1.currentStatus)}
                        >
                          {showPrice.format(item1.price)}
                          <span>
                            <small> تومان </small>
                          </span>
                        </p>
                      </Col>
                      {/* -------------------------------- وضعیت-------------------------------------------------------------*/}
                      {/* <Col
                        xs="5"
                        sm="4"
                        md="2"
                        onClick={() =>
                          handleSelect(item1.id, item1.currentStatus)
                        }
                      >
                        <p className={"text-md-center ml-6 ml-md-0 my-1 "}>
                          <span
                            className={
                              item1.currentStatus == 0
                                ? "text-primary "
                                : item1.currentStatus == 1
                                  ? "text-warning "
                                  : item1.currentStatus == 2
                                    ? "text-info "
                                    : item1.currentStatus == 3
                                      ? "text-success "
                                      : item1.currentStatus == 4 && "text-danger   "
                            }
                          >
                            {item1.currentStatusS}
                          </span>
                        </p>
                      </Col> */}

                      <Col xs="5" sm="3" md={item.hallEventId ? "1" : "2"} onClick={() => handleSelect(item1.id, item1.currentStatus)}>
                        <p className="tex-center ml-6 ml-md-0 my-1 ">
                          <span
                            className={
                              item1.cancelStatus == 0
                                ? "text-primary "
                                : item1.cancelStatus == 1
                                  ? "text-success "
                                  : item1.cancelStatus == 2
                                    ? "text-warning "
                                    : item1.cancelStatus == 3
                                      ? "text-info "
                                      : item1.cancelStatus == 4
                                        ? "text-danger   "
                                        : item1.cancelStatus == 5 ? "text-danger" : ""
                            }
                          >
                            {item1.cancelStatus == 0 ? "" : item1.cancelStatusS}
                          </span>
                        </p>
                      </Col>

                      <Col xs="3" sm="3" md="1" className="text-hover-primary  d-md-block my-2 ">
                        <div className="btn-group-sm d-flex justify-content-center ">
                          {!item1?.isDeleted ? (
                            <button
                              type="button"
                              className="btn btn-light-danger mx-1"
                              onClick={() => {
                                handleModalChangePerson(item1, item.id, item.amusementServiceName);
                              }}
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              data-bs-custom-class="tooltip-dark"
                              title={" حذف شماره تیکت " + item1.id}
                              data-bs-delay-hide="1000"
                            >
                              <p className="far fa-trash-alt  fa-sm  text-end my-0"></p>
                            </button>
                          ) : (
                            <div className="text-small">حذف شده</div>
                          )}
                          {/* {!item1?.isDeleted &&
                            <button
                              type="button"
                              className="btn  btn-light-secondary mx-1 "
                              onClick={handleShow({
                                nameModal: "historyItem",
                                size: "lg",
                                data: {
                                  BasketId: props.basketId,
                                  BasketItemId: item.id,
                                  BasketItemPersonId: item1.id,
                                },
                              })}
                            >
                              <p className="fas fa-history text-dark fa-sm my-0"></p>
                            </button>
                          } */}
                        </div>
                      </Col>
                    </div>
                    {/* <hr className="d-md-none" /> */}
                    {/* ==نمایش خطا در صورت وجود نداشتن فردی درون لیست افراد == */}
                  </div>
                ))
              ) : (
                <div className="text-danger  d-flex w-100   justify-content-center pb-4">
                  {" "}
                  <small className="text-danger ">برای این فعالیت هنوز فردی ثبت نشده است !!</small>{" "}
                </div>
              )}
            </div>

            {/* <Row className="d-md-none d-flex justify-content-center mt-3 mb-2">
                <Col xs="12" sm="4" className="text-hover-primary d-md-none  d-flex justify-content-center">
                  <button
                    type="button"
                    className="btn btn-sm w-100 btn-outline-primary m-0 "
                    onClick={() => {
                      handleModalSegane(item.id);
                    }}
                  >
                    <span className="fa fa-plus fa-sm mx-1"></span>
                    افزودن فرد
                  </button>
                </Col>
              </Row> */}
          </Card>
        ))}
      </div>
    </>
  );
}

export default NewBasketItemsIndex;
